import React, { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import { AnimatePresence } from "framer-motion";
import "./App.css";
import ScrollToTop from "./hooks/ScrollToTop";

const Home = lazy(() => import("./pages/Home"));
const Events = lazy(() => import("./pages/Events"));
const Team = lazy(() => import("./pages/Team"));
const DataHack2 = lazy(() => import("./pages/Datahack_2"));
const Xtract2 = lazy(() => import("./pages/Xtract_2"));
const Error = lazy(() => import("./pages/Error"));

function App() {
  const location = useLocation();
  return (
    <div className="h-screen">
      <Navbar />
      <AnimatePresence exitBeforeEnter initial={false}>
        <ScrollToTop />
        <Suspense fallback={<div className="min-h-screen bg-black" />}>
          <Routes location={location} key={location.pathname}>
            <Route key="home" path="/" element={<Home />} />
            <Route key="events" path="/events" element={<Events />} />
            <Route key="team" path="/team" element={<Team />} />
            <Route key="datahack-2.0" path="/datahack-2.0" element={<DataHack2/>} />
            <Route key='xtract-2.0' path='/xtract-2.0' element={<Xtract2/>}/>
            <Route key="error" path="/*" element={<Error/>} />
          </Routes>
        </Suspense>
      </AnimatePresence>
    </div>
  );
}

export default App;
